(function () {
  const menuRoot = () => document.querySelector('[data-duetras-menu]');
  const menuButton = () => document.querySelector('[data-duetras-menu-open]');
  let timer = 0;

  const placeMenu = (root) => {
    const headerSection = document.querySelector('.header-section');
    if (headerSection) {
      document.documentElement.style.setProperty(
        '--duetras-menu-top',
        headerSection.getBoundingClientRect().bottom + 'px'
      );
    }
    if (root.parentElement !== document.body) document.body.appendChild(root);
  };

  const closeMenu = () => {
    const root = menuRoot();
    const button = menuButton();
    const scrim = root && root.querySelector('[data-duetras-close]');
    if (button) button.setAttribute('aria-expanded', 'false');
    root?.classList.remove('is-open');
    scrim?.classList.remove('is-open');
    document.documentElement.classList.remove('duetras-menu-open');
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      if (root && !root.classList.contains('is-open')) {
        root.hidden = true;
        if (scrim) scrim.hidden = true;
      }
    }, 200);
  };

  const openMenu = () => {
    const root = menuRoot();
    const button = menuButton();
    if (!root || !button) return;
    const scrim = root.querySelector('[data-duetras-close]');
    window.clearTimeout(timer);
    placeMenu(root);
    root.hidden = false;
    if (scrim) scrim.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('duetras-menu-open');
    window.requestAnimationFrame(() => {
      root.classList.add('is-open');
      scrim?.classList.add('is-open');
    });
  };

  const showCategory = (root, id) => {
    root.querySelectorAll('[data-duetras-cat]').forEach((cat) => {
      cat.setAttribute('aria-selected', cat.getAttribute('data-duetras-cat') === id ? 'true' : 'false');
    });
    root.querySelectorAll('[data-duetras-panel]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-duetras-panel') !== id;
    });
    root.querySelectorAll('[data-duetras-feature]').forEach((feature) => {
      feature.hidden = feature.getAttribute('data-duetras-feature') !== id;
    });
  };

  const closest = (event, selector) =>
    event.target && event.target.closest ? event.target.closest(selector) : null;

  document.addEventListener('click', (event) => {
    const button = closest(event, '[data-duetras-menu-open]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      if (button.getAttribute('aria-expanded') === 'true') closeMenu();
      else openMenu();
      return;
    }
    if (closest(event, '[data-duetras-close]')) {
      closeMenu();
      return;
    }
    const cat = closest(event, '[data-duetras-cat]');
    const root = menuRoot();
    if (cat && root && root.contains(cat)) showCategory(root, cat.getAttribute('data-duetras-cat'));
  });

  document.addEventListener('mouseover', (event) => {
    const cat = closest(event, '[data-duetras-cat]');
    const root = menuRoot();
    if (cat && root && root.contains(cat)) showCategory(root, cat.getAttribute('data-duetras-cat'));
  });

  document.addEventListener('focusin', (event) => {
    const cat = closest(event, '[data-duetras-cat]');
    const root = menuRoot();
    if (cat && root && root.contains(cat)) showCategory(root, cat.getAttribute('data-duetras-cat'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const button = menuButton();
    if (button && button.getAttribute('aria-expanded') === 'true') {
      closeMenu();
      button.focus();
    }
  });

  window.addEventListener('resize', () => {
    const root = menuRoot();
    if (root && root.classList.contains('is-open')) placeMenu(root);
  });
})();
